module.exports = __webpack_public_path__ + "static/media/supply-chain-icon-blue.330a62ea.svg";